import React, { FC, useEffect, useState } from 'react'
import './EducationUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
interface propsType {
  toggleModal: () => void
  selectedEducation: any
  onSave: (data: EducationUpdate) => Promise<void>
}

export type EducationUpdate = {
  institutionName: string
  certificateEarned: string
  yearOfGraduation: string
  location: string
}

const schema = yup.object().shape({
  institutionName: yup.string().required('Field is required'),
  certificateEarned: yup.string().required('Field is required'),
  yearOfGraduation: yup.string().required('Field is required'),
  location: yup.string().required('Field is required'),
})

const EducationUpdate: FC<propsType> = ({
  toggleModal,
  selectedEducation,
  onSave,
}) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<EducationUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (selectedEducation) {
      reset({
        institutionName: selectedEducation.institutionName,
        certificateEarned: selectedEducation.certificateEarned,
        yearOfGraduation: selectedEducation.yearOfGraduation,
        location: selectedEducation.location,
      })
    } else {
      reset({
        institutionName: '',
        certificateEarned: '',
        yearOfGraduation: '',
        location: '',
      })
    }
  }, [selectedEducation, reset])

  const submitNewUserInformation = handleSubmit(async (data) => {
    setRequest(true)
    try {
      await onSave(data)

      toggleModal()
    } finally {
      setRequest(false)
    }
  })

  return (
    <div className='bank-update'>
      <form onSubmit={submitNewUserInformation}>
        {/* School */}
        <div className='form-group'>
          <label htmlFor='schoolAttended'>Institution Name</label>
          <input
            type='text'
            id='schoolAttended'
            className={`form-control ${errors.institutionName ? 'is-invalid' : ''}`}
            {...register('institutionName', {
              required: 'School is required',
            })}
          />
          {errors.institutionName && (
            <div className='invalid-feedback'>{errors.institutionName.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='degree'>Certificate Earned</label>
          <input
            type='text'
            id='degree'
            className={`form-control ${errors.certificateEarned ? 'is-invalid' : ''}`}
            {...register('certificateEarned', {
              required: 'Degree is required',
            })}
          />
          {errors.certificateEarned && (
            <div className='invalid-feedback'>{errors.certificateEarned.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='yearGraduated'>Year of Graduation</label>
          <input
            type='number'
            id='yearGraduated'
            className={`form-control ${errors.yearOfGraduation ? 'is-invalid' : ''}`}
            {...register('yearOfGraduation', {
              required: 'Year is required',
            })}
          />
          {errors.yearOfGraduation && (
            <div className='invalid-feedback'>{errors.yearOfGraduation.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='location'>Location</label>
          <input
            type='text'
            id='location'
            className={`form-control ${errors.location ? 'is-invalid' : ''}`}
            {...register('location', {
              required: 'Location is required',
            })}
          />
          {errors.location && <div className='invalid-feedback'>{errors.location.message}</div>}
        </div>

        <div className='form-group mt-4'>
          <button disabled={request} className='btn btn-default-2 w-100' type='submit'>
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default EducationUpdate
